import { render } from "./Intro.vue?vue&type=template&id=46d2b8aa&scoped=true"
import script from "./Intro.vue?vue&type=script&lang=js"
export * from "./Intro.vue?vue&type=script&lang=js"

import "./Intro.vue?vue&type=style&index=0&id=46d2b8aa&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46d2b8aa"]])

export default __exports__